import Vue from 'vue'

import { library }         from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Icons import
import 
{ 
	faTachometerAlt,
	faCalendarAlt,
	faCalendarCheck,
	faUsers,
	faSignOutAlt,
	faUserSecret,
	faAssistiveListeningSystems,
	faPhone,
	faFileInvoice,
	faEye,
	faMailBulk,
	faChartArea,
	faCog,
	faFlag,
	faSignInAlt,
	faTimes,
	faRetweet,
	faMicrophone,
	faMicrophoneSlash,
	faArrowUp,
	faArrowDown,
	faCircle,
	faPaste,
	faFilePdf,
	faFileExcel,
	faPlay,
	faPause,
	faStop,
	faVolumeUp,
	faVolumeMute,
	faFileSignature,
	faLock,
	faUnlock,
	faPaperclip,
	faListAlt,
	faVoicemail,
	faDownload,
} 
from '@fortawesome/free-solid-svg-icons'

// Add icons
library.add(
	faTachometerAlt,
	faCalendarAlt,
	faCalendarCheck,
	faUsers,
	faSignOutAlt,
	faUserSecret,
	faAssistiveListeningSystems,
	faPhone,
	faFileInvoice,
	faEye,
	faMailBulk,
	faChartArea,
	faCog,
	faFlag,
	faSignInAlt,
	faTimes,
	faRetweet,
	faMicrophone,
	faMicrophoneSlash,
	faArrowUp,
	faArrowDown,
	faCircle,
	faPaste,
	faFilePdf,
	faFileExcel,
	faPlay,
	faPause,
	faStop,
	faVolumeUp,
	faVolumeMute,
	faFileSignature,
	faLock,
	faUnlock,
	faPaperclip,
	faListAlt,
	faVoicemail,
	faDownload,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)